import { supabase } from "@/lib/supabase/client";
import type { Database, TableRow } from "@/types/database";

export type Customer = TableRow<"customers">;
export type CustomerInput = Omit<Database["public"]["Tables"]["customers"]["Insert"], "tenant_id">;

export async function listCustomers(tenantId: string) {
  const { data, error } = await supabase
    .from("customers")
    .select("id, tenant_id, name, code, contact_person, email, phone, address, is_active, created_at, updated_at")
    .eq("tenant_id", tenantId)
    .order("is_active", { ascending: false })
    .order("name");
  if (error) throw error;
  return data ?? [];
}

export async function getCustomer(tenantId: string, customerId: string) {
  const { data, error } = await supabase
    .from("customers")
    .select("id, tenant_id, name, code, contact_person, email, phone, address, is_active, created_at, updated_at")
    .eq("tenant_id", tenantId)
    .eq("id", customerId)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export async function createCustomer(tenantId: string, input: CustomerInput) {
  const { data, error } = await supabase
    .from("customers")
    .insert({ ...input, tenant_id: tenantId })
    .select("id, tenant_id, name, code, contact_person, email, phone, address, is_active, created_at, updated_at")
    .single();
  if (error) throw error;
  return data;
}

export async function updateCustomer(tenantId: string, customerId: string, input: CustomerInput) {
  const { data, error } = await supabase
    .from("customers")
    .update(input)
    .eq("tenant_id", tenantId)
    .eq("id", customerId)
    .select("id, tenant_id, name, code, contact_person, email, phone, address, is_active, created_at, updated_at")
    .single();
  if (error) throw error;
  return data;
}
